/* eslint-disable jsx-a11y/media-has-caption */
import { forwardRef, Ref } from "react";
import { cn } from "../../utils";
import { VidePlayer2PContext } from "./context";
import { useVVideoPlayer2 } from "./hooks";
import "./styles.scss";
import { VideoPlayer2Props, VideoPlayerManager2 } from "./types";
import { VideoPlayer2Controls } from "./VideoPlayer2Controls";
import { VideoLoading } from "./VideoPlayer2Controls/VideoLoading";
import { VideoPlayer2Setup } from "./VideoPlayer2Setup";

// TODO: Display buffered content in progress bar
// TODO: Manage qualities if hls is not applied.
// TODO: Save volume change, quality change, speed change.

/**
 * VideoPlayer2 Component
 * 
 * @example
 * // Basic usage with double-speed tap disabled (default)
 * <VideoPlayer2 url="video.mp4" />
 * 
 * @example
 * // Enable double-speed tap feature
 * <VideoPlayer2 url="video.mp4" enableDoubleSpeedTap={true} />
 */
function _VideoPlayer2(
  props: VideoPlayer2Props,
  ref: Ref<VideoPlayerManager2>,
) {
  const player = useVVideoPlayer2(props, ref);

  return (
    <VidePlayer2PContext.Provider value={player}>
      <VideoPlayer2Setup />
      <div
        className={cn("video-player-2-video-container", props.className)}
        ref={player.rootRef}
      >
        <VideoPlayer2Controls />
        <VideoLoading />
        <video
          tabIndex={-1}
          ref={player.videoRef}
          className="video-player-2-video"
          controls={false}
          controlsList="nodownload"
          playsInline
          preload="metadata"
        />
      </div>
    </VidePlayer2PContext.Provider>
  );
}

export const VideoPlayer2 = forwardRef(_VideoPlayer2);
